import { ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MisLinkProps {
  misId: string;
  misTranId: string | null;
  url: string;
  className?: string;
}

/**
 * Renders a MIS transaction number as a clickable link to the NetSuite
 * Inventory Adjustment record, opening in a new tab. Falls back to "MIS #{misId}"
 * when the tranId fetch failed at post-time (self-heal backfills it on next load).
 */
export function MisLink({ misId, misTranId, url, className }: MisLinkProps) {
  const label = misTranId && misTranId.length > 0 ? misTranId : `MIS #${misId}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className={cn(
        'inline-flex items-center gap-1 font-mono text-foreground underline underline-offset-2 decoration-muted-foreground/50 hover:decoration-foreground transition-colors',
        className,
      )}
    >
      {label}
      <ExternalLink className="h-3 w-3 flex-shrink-0" />
    </a>
  );
}
